// discountCodePlugin.js
var graphqlEndpoint = "https://loveshop.ca/api/2023-01/graphql.json";
var storefrontAccessToken = "09b3ae3622a15d4b0151522aeb76c484";

// constants
var invalidDiscountCodeError = "This discount can't be used with existing discounts";
var unknownError = "We are having trouble applying that discount code, please try again later";
var defaultDiscounts = "DISCOUNTS";

function getCookieFieldValue(cookieName) {
    var cookieValue = document.cookie.split(';')
        .map(cookie => cookie.trim())
        .filter(cookie =>  cookie.split('=')[0] === cookieName)
        .map(cookie => cookie.split('=')[1])[0];
    if (!cookieValue) {
        throw new Error("Cookie field not present " + cookieName)
    }
    return decodeURIComponent(cookieValue);
}

var applyDiscountMutation = `mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]) {
    cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
      cart {
        id
        cost {
            checkoutChargeAmount {
                amount
                currencyCode
            }
            totalAmount {
                amount
                currencyCode
            }
            subtotalAmount {
                amount
                currencyCode
            }
            totalTaxAmount {
                amount
                currencyCode
            }
        }
        discountCodes {
            applicable
            code
        }
        lines(first: 100) {
            edges {
                node {
                    discountAllocations {
                        discountedAmount {
                            amount
                        }
                    }
                }
            }
        }
      }
      userErrors {
        field
        message
      }
    }
}`;

var interval;

function updateDiscountFields(checkoutAmount, discountAmount, discountCode, isApplied, currencyCode) {
    function formatCurrency(value) {
        return `$ ${value?.toFixed(2)} ${currencyCode}`;
    }
    // whenever we update kill the previous updating background logic
    clearInterval(interval);
    if (!isNaN(discountAmount) && discountAmount > 0) {
        var total = checkoutAmount + discountAmount;
        var percentage = (discountAmount / total) * 100;
        percentage = isFinite(percentage) ? percentage : 100;
        document.getElementById("discount-name").innerText = (isApplied) ? discountCode : defaultDiscounts;
        document.getElementById("discount-subtotal").innerText = formatCurrency(total);
        document.getElementById("discount-percent").innerText = `(${percentage.toFixed(0)} %)`;
        document.getElementById("discount-discount").innerText = formatCurrency(0 - discountAmount);
        document.getElementById("discount-total").innerText = formatCurrency(checkoutAmount);
        document.getElementById("current-cart-value").setAttribute("data-header-cart-price",checkoutAmount * 100); // We multiply by 100 here because the theme code structures it that way, so my code does too.
        document.getElementById("discount-subtotals").style.removeProperty("display");
    } else {
        document.getElementById("discount-subtotals").style.display = "none";
    }
    
    var removeDiscountElement = document.getElementById("discount-code-remove");
    if(isApplied) {
        removeDiscountElement.style.removeProperty("display");
    } else {
        removeDiscountElement.style.display = "none";
        var cartTotalRedux = checkoutAmount; // We use these lines to update the cart price so my code is aware of a discount code being removed.
        document.getElementById("current-cart-value").setAttribute("data-header-cart-price",cartTotalRedux * 100); // ^
    }
  
    // this is a hack to integrate with the existing theme total:
    // there doesn't seem to be a way to get the cart to respect discounts so this updates the cart, we do this in an interval
    // as the theme cart update is async, and rather than figure out how to await this, we just update for 5 seconds
    var times = 0;
    interval = setInterval(function() {
      var themeTotal = document.querySelector("[data-cart-final]");
      if (themeTotal) {
        var formatted = formatCurrency(checkoutAmount);
        if (themeTotal.innerText !== formatted) {
          themeTotal.innerText = formatCurrency(checkoutAmount);
        } else if (times >= 10) {
          clearInterval(interval);
        }
        times += 1;
      }
    }, 500);
}

function handleDiscount(isValid, error, discountCode) {
    // refresh cart using theme-specific custom event
    ["theme:cart:reload"].forEach(function(eventName) {
      var e = document.createEvent("HTMLEvents");
      e.initEvent(eventName, true, true);
      e.eventName = eventName;
      document.dispatchEvent(e);
    });
    
    // handle error scenarios
    var errorElement = document.getElementById("discount-code-error");
    if (!isValid && discountCode) {
        errorElement.innerText = invalidDiscountCodeError;
    } else if (error && discountCode) {
        errorElement.innerText = unknownError;
    } else {
        document.getElementById("discount-code-value").value = "";
        errorElement.innerText = "";
    }
}

function updateCartData(cartPromise, cartAccessor, discountCode) {
  return cartPromise
    .then(response => response.json())
    .then(data => {
        var cart = cartAccessor(data);
        var isValid = cart?.discountCodes && cart.discountCodes[0] && cart.discountCodes[0].applicable === true;
        handleDiscount(isValid, null, discountCode);
        var discountCodeName = cart?.discountCodes && cart.discountCodes[0] && cart.discountCodes[0].code;
        var totalAmount = parseFloat(cart?.cost?.totalAmount?.amount);
        var taxAmount = parseFloat(cart?.cost?.totalTaxAmount?.amount) || 0; // Modified variable to catch NaN calculation and output zero.
        var checkoutAmount = totalAmount - taxAmount;
        var currencyCode = cart?.cost?.checkoutChargeAmount?.currencyCode;
        var totalDiscount = 0;
        (
            cart?.lines?.edges || []
        ).forEach(function(node) {
            node.node.discountAllocations.forEach(function(discountAmount) {
                totalDiscount += parseFloat(discountAmount.discountedAmount.amount);
            })
        })
        updateDiscountFields(checkoutAmount, totalDiscount, discountCodeName, isValid, currencyCode);
    })
    .catch(error => {
        handleDiscount(false, error, discountCode);
        updateDiscountFields(0, 0, "", false, "");
    });
}

function applyDiscountCode(discountCode) {
    var mutation = fetch(graphqlEndpoint, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
        },
        body: JSON.stringify({
            query: applyDiscountMutation,
            variables: {
                cartId: `gid://shopify/Cart/${getCookieFieldValue("cart")}`,
                discountCodes: [
                    discountCode
                ]
            },
        }),
    });
    function cartAccessor(data) {
      return data?.data?.cartDiscountCodesUpdate?.cart;
    }
    updateCartData(mutation, cartAccessor, discountCode);
}

function initState() {
  var cartId = `gid://shopify/Cart/${getCookieFieldValue("cart")}`;
  var query = `
    query {
      cart(id: "${cartId}") {
        id
        cost {
            checkoutChargeAmount {
                amount
                currencyCode
            }
            totalAmount {
                amount
                currencyCode
            }
            subtotalAmount {
                amount
                currencyCode
            }
            totalTaxAmount {
                amount
                currencyCode
            }
        }
        discountCodes {
            applicable
            code
        }
        lines(first: 100) {
            edges {
                node {
                    discountAllocations {
                        discountedAmount {
                            amount
                        }
                    }
                }
            }
        }
      }
    }
  `;
  var cartData = fetch(graphqlEndpoint, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
        },
        body: JSON.stringify({
            query
        }),
    });
  function cartAccessor(data) {
      return data?.data?.cart;
    }

  updateCartData(cartData, cartAccessor, "");
}

(function init() {
  initState();
  
  document.getElementById("discount-code-apply").onclick = function() {
    var value = document.getElementById("discount-code-value").value;
    applyDiscountCode((value || "").toUpperCase());
  }

  document.getElementById("discount-code-remove").onclick = function() {
    applyDiscountCode("");
  }

  document.addEventListener("theme:cart:change", initState);
  document.addEventListener("theme:drawer:open", initState);
}());

